import '../Admin/admin-shared.css'
import '../tools-pages.css'

import { InputTextarea } from 'primereact/inputtextarea'
import { useEffect, useState } from 'react'
import { useNavigate, useParams } from 'react-router-dom'

import { PageHeader } from '../../Components'
import { FC, invalidateQuery, useCQuery } from '../../Services'
import { cap } from '../../State'
import { translations } from '../../translations'
import { showToast } from '../../utils/toast'

const language = cap.language.state || 'IT'
const t = translations[language] || translations.IT

export default function NewPrompt() {
  const { promptId } = useParams()
  const { data: prompt, isSuccess } = useCQuery(['prompt', parseInt(promptId)])
  const [basePrompt, setBasePrompt] = useState('')
  const [preExtractPrompt, setPreExtractPrompt] = useState('')
  const [postExtractPrompt, setPostExtractPrompt] = useState('')
  const [type, setType] = useState('')
  const [jsonField, setJsonField] = useState('')
  const navigate = useNavigate()
  const isNew = promptId === 'new'

  const savePrompt = async () => {
    if (!basePrompt || !preExtractPrompt || !postExtractPrompt || !type) {
      return showToast('error', t.errore, t.mxCompilaCampi)
    }
    try {
      const result = isNew
        ? await FC.service('prompts').create({
            basePrompt,
            preExtractPrompt,
            postExtractPrompt,
            type,
            jsonField,
            user: 'andrea'
          })
        : await FC.service('prompts').patch(promptId, {
            basePrompt,
            preExtractPrompt,
            postExtractPrompt,
            type,
            jsonField,
            user: 'andrea'
          })
      if (result) {
        showToast('success', t.success, t.mxPromptCreato)
        navigate('/prompts/' + result.id)
      }
      invalidateQuery(['prompts', 'prompt'])
    } catch (error) {
      showToast('error', t.errore, error?.message || 'Errore durante il salvataggio')
    }
  }

  useEffect(() => {
    if (isSuccess) {
      const {
        basePrompt = '',
        preExtractPrompt = '',
        postExtractPrompt = '',
        type = '',
        jsonField = ''
      } = prompt || {}
      setBasePrompt(basePrompt)
      setPreExtractPrompt(preExtractPrompt)
      setPostExtractPrompt(postExtractPrompt)
      setType(type)
      setJsonField(jsonField)
    }
  }, [isSuccess])

  const textareaStyle = {
    width: '100%',
    borderRadius: 8,
    border: '1px solid var(--border-strong)',
    padding: '10px 12px',
    fontFamily: 'var(--font-family)',
    fontSize: 13,
    color: 'var(--ink-900)',
    background: 'var(--surface)',
    resize: 'vertical'
  }

  const monoTextareaStyle = {
    ...textareaStyle,
    fontFamily: 'var(--font-mono)',
    fontSize: 12.5,
    lineHeight: 1.55,
    minHeight: 120
  }

  return (
    <div className="prompts-page admin-page--medium">
      <PageHeader
        title={isNew ? t.mxCreazionePrompt : t.mxModificaPrompt}
        subtitle={jsonField ? <span className="prompt-json-field">{jsonField}</span> : undefined}
        actions={
          <>
            <button type="button" className="nbtn" onClick={() => navigate('/prompts/list')}>
              <i className="pi pi-chevron-left" style={{ fontSize: 14 }} />
              {t.tornaIndietro}
            </button>
            <button type="button" className="nbtn nbtn--primary" onClick={savePrompt}>
              <i className="pi pi-check" style={{ fontSize: 14 }} />
              {t.salva}
            </button>
          </>
        }
      />

      <div className="nsec">
        <div className="nsec__head">
          <div className="nsec__ico">
            <i className="pi pi-bolt" style={{ fontSize: 16 }} />
          </div>
          <h3 className="nsec__title">{t.mxConfigurazionePrompt}</h3>
        </div>
        <div className="nsec__body">
          <div className="nrow">
            <div className="nfield" style={{ gridColumn: 'span 6' }}>
              <label>{t.mxChiaveCampoJson}</label>
              <InputTextarea
                value={jsonField}
                onChange={(e) => setJsonField(e.target.value)}
                style={{ ...textareaStyle, fontFamily: 'var(--font-mono)', minHeight: 40 }}
              />
            </div>
            <div className="nfield" style={{ gridColumn: 'span 6' }}>
              <label>{t.tipo}</label>
              <InputTextarea
                value={type}
                onChange={(e) => setType(e.target.value)}
                style={{ ...textareaStyle, minHeight: 40 }}
              />
            </div>
            <div className="nfield" style={{ gridColumn: 'span 12' }}>
              <label>{t.mxSpiegazioneCampo}</label>
              <InputTextarea
                value={basePrompt}
                onChange={(e) => setBasePrompt(e.target.value)}
                rows={4}
                autoResize
                style={{ ...textareaStyle, minHeight: 80 }}
              />
            </div>
            <div className="nfield" style={{ gridColumn: 'span 12' }}>
              <label>PreExtractPrompt</label>
              <InputTextarea
                value={preExtractPrompt}
                onChange={(e) => setPreExtractPrompt(e.target.value)}
                rows={6}
                autoResize
                style={monoTextareaStyle}
              />
            </div>
            <div className="nfield" style={{ gridColumn: 'span 12' }}>
              <label>PostExtractPrompt</label>
              <InputTextarea
                value={postExtractPrompt}
                onChange={(e) => setPostExtractPrompt(e.target.value)}
                rows={6}
                autoResize
                style={monoTextareaStyle}
              />
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
